// import React, { useState } from "react";
// import * as FeatherIcon from "react-feather";
// import "./CompanyBaselineProfile.css";

// const CompanyBaselineProfile = () => {
//   const [activeTab, setActiveTab] = useState("products");

//   const tabs = [
//     { key: "products", label: "Products" },
//     { key: "markets", label: "Markets" },
//     { key: "operations", label: "Operations" },
//     { key: "distribution", label: "Distribution" },
//     { key: "customers", label: "Customers" },
//     { key: "competition", label: "Competition" },
//   ];

//   return (
//     <div className="company_baseline_wrapper">
//       {/* Header */}
//       <div className="company_head_block">
//         <h3 className="company_name">📋 Company Baseline Profile</h3>
//         <div className="overall_confidance">Overall Confidence: 78%</div>
//       </div>

//       {/* Tabs */}
//       <div className="company_tab_wrapper">
//         <div className="company_tab_row">
//           {tabs.map((tab) => (
//             <button
//               className={`copmany_tab_btn ${
//                 activeTab === tab.key ? "company_tab_btn_active" : ""
//               }`}
//               key={tab.key}
//               onClick={() => setActiveTab(tab.key)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Tab Content */}
//       <div className="company_tab_content_wrapper">
//         {/* Products */}
//         {activeTab === "products" && (
//           <div className="company_content_block">
//             <table
//               className="custom-resizable-table mb-0"
//               style={{ width: "100%", borderCollapse: "collapse" }}
//             >
//               <thead className="">
//                 <tr
//                   className="custom-resizable-table-header"
//                   style={{ background: "#f1f5f9" }}
//                 >
//                   <th className="" style={{ fontSize: "12px" }}>
//                     <div className="custom-resizable-table-th-content">
//                       Product Line
//                     </div>
//                   </th>
//                   <th className="" style={{ fontSize: "12px" }}>
//                     <div className="custom-resizable-table-th-content">
//                       {" "}
//                       Strategic Category
//                     </div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="">
//                 {[
//                   [
//                     "Chromatin Profiling (SimpleChIP, CUT&RUN, CUT&Tag) ",
//                     "CASH COW (SimpleChIP) + GROWTH ENGINE (CUT&RUN/Tag)",
//                     "#dc2626",
//                   ],
//                   [
//                     "Primary Antibodies & Conjugates (Rabbit mAb, SignalFlex)",
//                     "CASH COW",
//                     "#dc2626",
//                   ],
//                   [
//                     "Proteomics Analytical Services (PTMScan & Targeted/Discovery)",
//                     "DIVERSIFICATION + STRATEGIC DEFENSE",
//                     "#dc2626",
//                   ],
//                   [
//                     "Cytokines & Growth Factors (Recombinant Proteins)",
//                     "DIVERSIFICATION",
//                     "#059669",
//                   ],
//                   [
//                     "SignalStar Multiplex IHC Kits & Reagents",
//                     "GROWTH ENGINE",
//                     "#059669",
//                   ],
//                   [
//                     "InTraSeq Single‑Cell Protein+RNA (3’ workflow)",
//                     "INNOVATION SHOWCASE → GROWTH ENGINE",
//                     "#059669",
//                   ],
//                   [
//                     "WB/IP Detection, Secondary Antibodies, and Buffers",
//                     "PORTFOLIO FILL + STRATEGIC DEFENSE",
//                     "#059669",
//                   ],
//                   [
//                     "PathScan ELISA Kits & Antibody Pairs",
//                     "PORTFOLIO FILL → CASH COW",
//                     "#6366f1",
//                   ],
//                   [
//                     "Custom & Bulk Services (Formulations, Conjugation, Peptides)",
//                     "STRATEGIC DEFENSE",
//                     "#6366f1",
//                   ],
//                   // [
//                   //   "Technical & Manufacturing Services",
//                   //   "STRATEGIC DEFENSE",
//                   //   "#059669",
//                   // ],
//                 ].map(([line, category, bg], i) => (
//                   <tr
//                     className="gtr-row"
//                     key={i}
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">{line}</td>
//                     <td className="gtr-cell" style={{ fontSize: "11px" }}>
//                       <span
//                         className="company_content_td_span"
//                         style={{
//                           background: bg,
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         {category}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Markets */}
//         {activeTab === "markets" && (
//           <div className="company_content_block">
//             {/* Market by Technology */}
//             <div style={{ marginBottom: "25px" }}>
//               <h5 className="market_head_custom">Market by Technology</h5>
//               <div>
//                 <table
//                   className="custom-resizable-table mb-0"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       className="custom-resizable-table-header"
//                       style={{ background: "#f1f5f9" }}
//                     >
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Technology Segment
//                         </div>
//                       </th>
//                       <th style={{ textAlign: "center" }}>
//                         <div className="custom-resizable-table-th-content">
//                           Company Revenue %
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {[
//                       [
//                         "Hot-melt adhesives (EVA, HMPSA, APAO, mPE/mPP, PUR)",
//                         "30%",
//                       ],
//                       ["Water-based adhesives (PVA, VAE, VAA)", "25%"],
//                       [
//                         "Emulsion polymerization (PVAc, VAA, specialty latexes)",
//                         "10%",
//                       ],
//                       ["Urea and synthetic resin adhesive systems", "10%"],
//                       ["Masonry foam insulation (Core-Fill 500)", "8%"],
//                       ["Toll manufacturing and private labeling", "7%"],
//                       ["Urethane adhesives (filter industry focus)", "5%"],
//                       ["Contact cements (water- & solvent-based)", "3%"],
//                       ["Foam-in-place packaging systems", "2%"],
//                     ].map(([segment, percent], i) => (
//                       <tr
//                         className="gtr-row"
//                         key={i}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                       >
//                         <td className="gtr-cell">{segment}</td>
//                         <td
//                           className="gtr-cell"
//                           style={{
//                             textAlign: "left",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {parseInt(percent) >= 25
//                             ? "HIGH (~" + percent + ")"
//                             : parseInt(percent) >= 10 && parseInt(percent) <= 20
//                             ? "MEDIUM (~" + percent + ")"
//                             : "LOW (~" + percent + ")"}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Market by Application */}
//             <div style={{ marginBottom: "25px" }}>
//               <h5 className="market_head_custom">Market by Application</h5>
//               <div>
//                 <table
//                   className="custom-resizable-table mb-0"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       className="custom-resizable-table-header"
//                       style={{ background: "#f1f5f9" }}
//                     >
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Application Segment
//                         </div>
//                       </th>
//                       {/* <th style={{ textAlign: "center" }}>
//                         <div className="custom-resizable-table-th-content">
//                           {" "}
//                           Company Revenue %
//                         </div>
//                       </th> */}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {[
//                       [
//                         "Case & Carton Packaging (Hot-melt adhesives)",
//                         // "25.00%",
//                       ],
//                       [
//                         "Corrugated & Paper Converting (Emulsion/water-based)",
//                         // "15.00%",
//                       ],
//                       [
//                         "Labeling & Graphics (Label adhesives, HMPSA & water-based)",
//                         // "12.00%",
//                       ],
//                       [
//                         "Woodworking & Engineered Wood (Urea/synthetic resins, PVAc, PUR)",
//                         // "12.00%",
//                       ],
//                       [
//                         "Nonwovens & Hygiene (APAO & HMPSA hot-melts)",
//                         // "10.00%",
//                       ],
//                       [
//                         "Construction Insulation (Core-Fill 500 masonry foam)",
//                         // "10.00%",
//                       ],
//                       ["Laminating (Film/Foil/Paperboard)", "7.00%"],
//                       [
//                         "Envelope & Paper Stationery (Dextrin/water-based gums)",
//                         // "5.00%",
//                       ],
//                       [
//                         "Filter Manufacturing (Urethane adhesives for V-Cell/HEPA)",
//                         // "4.00%",
//                       ],
//                     ].map(([segment, percent], i) => (
//                       <tr
//                         className="gtr-row"
//                         key={i}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                       >
//                         <td className="gtr-cell">{segment}</td>
//                         {/* <td
//                           className="gtr-cell"
//                           style={{
//                             textAlign: "center",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {percent}
//                         </td> */}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Market by Geography */}
//             <div>
//               <h5 className="market_head_custom">Market by Geography</h5>
//               <div>
//                 <table
//                   className="custom-resizable-table mb-0"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       className="custom-resizable-table-header"
//                       style={{ background: "#f1f5f9" }}
//                     >
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Geography Segment
//                         </div>
//                       </th>
//                       <th style={{ textAlign: "center" }}>
//                         <div className="custom-resizable-table-th-content">
//                           Company Revenue %
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {[
//                       [
//                         "United States (North America) — primary operating geography",
//                         "90%",
//                       ],
//                       [
//                         "Mexico (North America) — export/tolling adjacency",
//                         "5%",
//                       ],
//                       ["Canada (North America) — export adjacency", "5%"],
//                     ].map(([geo, percent], i) => (
//                       <tr
//                         className="gtr-row"
//                         key={i}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                       >
//                         <td className="gtr-cell">{geo}</td>
//                         <td
//                           className="gtr-cell"
//                           style={{
//                             textAlign: "left",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {parseInt(percent) >= 25
//                             ? "HIGH (~" + percent + ")"
//                             : parseInt(percent) >= 10 && parseInt(percent) <= 20
//                             ? "MEDIUM (~" + percent + ")"
//                             : "LOW (~" + percent + ")"}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Other Tabs Placeholders */}
//         {/* ---------------- Operations Tab ---------------- */}
//         {activeTab === "operations" && (
//           <div>
//             <h5 className="market_head_custom">Manufacturing Footprint</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Facility
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Location
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Function
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         {" "}
//                         Risk Level
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🏢 Hickory HQ</td>
//                     <td className="gtr-cell">Hickory, NC</td>
//                     <td className="gtr-cell">325K sq ft, Main Operations</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🔥 Hot-Melt Plant</td>
//                     <td className="gtr-cell">North Carolina</td>
//                     <td className="gtr-cell">Specialized Production</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🧪 Thomasville Resins</td>
//                     <td className="gtr-cell">Thomasville, NC</td>
//                     <td className="gtr-cell">Resin Manufacturing</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                   </tr>
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">💧 Emulsion Plant</td>
//                     <td className="gtr-cell">North Carolina</td>
//                     <td className="gtr-cell">Polymer Production</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #ef4444",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>⚠️</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#dc2626",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Critical Geographic Concentration Risk
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>100% North Carolina Operations:</strong> Single-state
//                 concentration creates catastrophic supply chain vulnerability...
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ---------------- Distribution Tab ---------------- */}
//         {activeTab === "distribution" && (
//           <div>
//             <h5 className="market_head_custom">Go-to-Market Channels</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Channel Type
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Sales %
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Description
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         {" "}
//                         Strategic Impact
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🏪 Dealer Network</td>
//                     <td className="gtr-cell">70%</td>
//                     <td className="gtr-cell">
//                       Regional distributors and resellers
//                     </td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         HIGH MARGIN LOSS
//                       </span>
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🚛 Direct Fleet</td>
//                     <td className="gtr-cell">20%</td>
//                     <td className="gtr-cell">Tractors, Tankers, Box Trucks</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#10b981",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         OPTIMAL
//                       </span>
//                     </td>
//                   </tr>
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">🤝 Private Label</td>
//                     <td className="gtr-cell">10%</td>
//                     <td className="gtr-cell">Tolling Partnerships</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#f59e0b",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         MODERATE
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             <div
//               style={{
//                 background: "#fef3c7",
//                 border: "1px solid #f59e0b",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>📊</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#92400e",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Distribution Strategy Analysis
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Margin Vulnerability:</strong> 70% distributor reliance
//                 surrenders an estimated $10-17M annually in margins vs direct
//                 sales model...
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ---------------- Customers Tab ---------------- */}
//         {activeTab === "customers" && (
//           <div>
//             <h5 className="market_head_custom">Customer Segment Analysis</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Customer Segment
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Market Position
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Top Use Cases
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* Row 1 */}
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">
//                       Industrial Adhesives for Furniture and Woodworking
//                       Manufacturers
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(4)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#10b981",
//                             }}
//                           ></div>
//                         ))}
//                         <div
//                           style={{
//                             width: "8px",
//                             height: "8px",
//                             borderRadius: "50%",
//                             background: "#e5e7eb",
//                           }}
//                         ></div>
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Strong Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Wood bonding, edge banding, panel lamination
//                     </td>
//                   </tr>
//                   {/* Row 2 */}
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">
//                       HVAC and Air Filtration Manufacturers
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(2)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#f59e0b",
//                             }}
//                           ></div>
//                         ))}
//                         {[...Array(3)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#e5e7eb",
//                             }}
//                           ></div>
//                         ))}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Moderate Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Filter pleating, frame bonding, media sealing
//                     </td>
//                   </tr>
//                   {/* Row 3 */}
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">
//                       Packaging and Corrugated Box Manufacturers
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(4)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#10b981",
//                             }}
//                           ></div>
//                         ))}
//                         <div
//                           style={{
//                             width: "8px",
//                             height: "8px",
//                             borderRadius: "50%",
//                             background: "#e5e7eb",
//                           }}
//                         ></div>
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Strong Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Case sealing, tray forming, carton closing, corrugated
//                       assembly
//                     </td>
//                   </tr>
//                   {/* Row 4 */}
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">
//                       OEM and Custom Manufacturing Clients
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(2)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#f59e0b",
//                             }}
//                           ></div>
//                         ))}
//                         {[...Array(3)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#e5e7eb",
//                             }}
//                           ></div>
//                         ))}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Moderate Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Custom adhesive formulation, private label manufacturing
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* ---------------- Competition Tab ---------------- */}
//         {activeTab === "competition" && (
//           <div>
//             <h5 className="market_head_custom">Competitive Landscape</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Competitor Category
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Key Players
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Threat Level
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Competitive Advantage
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🌍 Global Giants</td>
//                     <td className="gtr-cell">
//                       Henkel, H.B. Fuller, Bostik, 3M, Sika
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                     <td className="gtr-cell">
//                       Scale, R&D, global reach, portfolio breadth
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🏢 Regional/Niche</td>
//                     <td className="gtr-cell">
//                       TRCC, WORTHEN, Chemique Adhesives, Attie Adhesives, VALPAC
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <span
//                         style={{
//                           background: "#f59e0b",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         MEDIUM
//                       </span>
//                     </td>
//                     <td className="gtr-cell">
//                       Specialized focus, regional expertise, agility
//                     </td>
//                   </tr>
//                   {/* <tr>
//                     <td
//                       style={{
//                         padding: "10px 15px",
//                         fontSize: "12px",
//                         color: "#374151",
//                         fontWeight: 600,
//                       }}
//                     >
//                       ⚔️ Direct Overlap
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px 15px",
//                         fontSize: "12px",
//                         color: "#374151",
//                       }}
//                     >
//                       Sealed Air (foam), Hexion/GP (resins)
//                     </td>
//                     <td style={{ padding: "10px 15px", textAlign: "center" }}>
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "white",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                     <td
//                       style={{
//                         padding: "10px 15px",
//                         fontSize: "12px",
//                         color: "#374151",
//                       }}
//                     >
//                       Product overlap, established relationships
//                     </td>
//                   </tr> */}
//                 </tbody>
//               </table>
//             </div>

//             {/* Competitive Analysis */}
//             <div
//               style={{
//                 background: "#f0f9ff",
//                 border: "1px solid #3b82f6",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>🎯</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#1e40af",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Competitive Positioning Analysis
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Strategic Position:</strong> Tailored Chemical competes
//                 on agility and service quality (5.0/5.0 rating) vs scale and
//                 portfolio breadth. Key vulnerability: no IP protection enables
//                 formula replication by larger competitors with resources.
//               </div>
//             </div>

//             {/* Market Dynamics */}
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #ef4444",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "15px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>⚠️</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#dc2626",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Competitive Threats
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Scale Disadvantage:</strong> 35x smaller than H.B.
//                 Fuller ($101.9M vs $3.57B). Global giants can absorb price
//                 competition and outspend on R&D. Regional focus creates both
//                 protection and limitation.
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CompanyBaselineProfile;

// import React, { useState } from "react";
// import * as FeatherIcon from "react-feather";
// import "./CompanyBaselineProfile.css";

// const CompanyBaselineProfile = () => {
//   const [activeTab, setActiveTab] = useState("products");

//   const tabs = [
//     { key: "products", label: "Products" },
//     { key: "markets", label: "Markets" },
//     { key: "operations", label: "Operations" },
//     { key: "distribution", label: "Distribution" },
//     { key: "customers", label: "Customers" },
//     { key: "competition", label: "Competition" },
//   ];

//   return (
//     <div className="company_baseline_wrapper">
//       {/* Header */}
//       <div className="company_head_block">
//         <h3 className="company_name">📋 Company Baseline Profile</h3>
//         <div className="overall_confidance">Overall Confidence: 85%</div>
//       </div>

//       {/* Tabs */}
//       <div className="company_tab_wrapper">
//         <div className="company_tab_row">
//           {tabs.map((tab) => (
//             <button
//               className={`copmany_tab_btn ${
//                 activeTab === tab.key ? "company_tab_btn_active" : ""
//               }`}
//               key={tab.key}
//               onClick={() => setActiveTab(tab.key)}
//             >
//               {tab.label}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Tab Content */}
//       <div className="company_tab_content_wrapper">
//         {/* Products */}
//         {activeTab === "products" && (
//           <div className="company_content_block">
//             <table
//               className="custom-resizable-table mb-0"
//               style={{ width: "100%", borderCollapse: "collapse" }}
//             >
//               <thead className="">
//                 <tr
//                   className="custom-resizable-table-header"
//                   style={{ background: "#f1f5f9" }}
//                 >
//                   <th className="" style={{ fontSize: "12px" }}>
//                     <div className="custom-resizable-table-th-content">
//                       Product Line
//                     </div>
//                   </th>
//                   <th className="" style={{ fontSize: "12px" }}>
//                     <div className="custom-resizable-table-th-content">
//                       {" "}
//                       Strategic Category
//                     </div>
//                   </th>
//                 </tr>
//               </thead>
//               <tbody className="">
//                 {[
//                   [
//                     "Chromatin Profiling (SimpleChIP, CUT&RUN, CUT&Tag) ",
//                     "CASH COW (SimpleChIP) + GROWTH ENGINE (CUT&RUN/Tag)",
//                     "#dc2626",
//                   ],
//                   [
//                     "Primary Antibodies & Conjugates (Rabbit mAb, SignalFlex)",
//                     "CASH COW",
//                     "#dc2626",
//                   ],
//                   [
//                     "Proteomics Analytical Services (PTMScan & Targeted/Discovery)",
//                     "DIVERSIFICATION + STRATEGIC DEFENSE",
//                     "#dc2626",
//                   ],
//                   [
//                     "Cytokines & Growth Factors (Recombinant Proteins)",
//                     "DIVERSIFICATION",
//                     "#059669",
//                   ],
//                   [
//                     "SignalStar Multiplex IHC Kits & Reagents",
//                     "GROWTH ENGINE",
//                     "#059669",
//                   ],
//                   [
//                     "InTraSeq Single‑Cell Protein+RNA (3′ workflow)",
//                     "INNOVATION SHOWCASE → GROWTH ENGINE",
//                     "#059669",
//                   ],
//                   [
//                     "WB/IP Detection, Secondary Antibodies, and Buffers",
//                     "PORTFOLIO FILL + STRATEGIC DEFENSE",
//                     "#059669",
//                   ],
//                   [
//                     "PathScan ELISA Kits & Antibody Pairs",
//                     "PORTFOLIO FILL → CASH COW",
//                     "#6366f1",
//                   ],
//                   [
//                     "Custom & Bulk Services (Formulations, Conjugation, Peptides)",
//                     "STRATEGIC DEFENSE",
//                     "#6366f1",
//                   ],
//                 ].map(([line, category, bg], i) => (
//                   <tr
//                     className="gtr-row"
//                     key={i}
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">{line}</td>
//                     <td className="gtr-cell" style={{ fontSize: "11px" }}>
//                       <span
//                         className="company_content_td_span"
//                         style={{
//                           background: bg,
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         {category}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Markets */}
//         {activeTab === "markets" && (
//           <div className="company_content_block">
//             {/* Market by Technology */}
//             <div style={{ marginBottom: "25px" }}>
//               <h5 className="market_head_custom">Market by Technology</h5>
//               <div>
//                 <table
//                   className="custom-resizable-table mb-0"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       className="custom-resizable-table-header"
//                       style={{ background: "#f1f5f9" }}
//                     >
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Technology Segment
//                         </div>
//                       </th>
//                       <th style={{ textAlign: "center" }}>
//                         <div className="custom-resizable-table-th-content">
//                           Company Revenue %
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {[
//                       [
//                         "Recombinant Rabbit Monoclonal Antibodies (RUO primary antibodies)",
//                         "58%",
//                       ],
//                       [
//                         "Conjugated/Carrier-free Antibodies and Custom Labeling (Reagent kits and services)",
//                         "12%",
//                       ],
//                       [
//                         "Multiplex Immunohistochemistry (SignalStar mIHC; Platform/Reagents)",
//                         "6%",
//                       ],
//                       ["PathScan ELISA Kits (RUO immunoassays)", "8%"],
//                       [
//                         "Proteomics Analytical Services (PTMScan Discovery/Direct, TMT Total Proteome)",
//                         "7%",
//                       ],
//                       [
//                         "Chromatin Profiling (SimpleChIP Kits & Reagents)",
//                         "6%",
//                       ],
//                       [
//                         "Single-Cell Multimodal Protein+RNA (InTraSeq; Platform/Reagents)",
//                         "3%",
//                       ],
//                     ].map(([segment, percent], i) => (
//                       <tr
//                         className="gtr-row"
//                         key={i}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                       >
//                         <td className="gtr-cell">{segment}</td>
//                         <td
//                           className="gtr-cell"
//                           style={{
//                             textAlign: "left",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {parseInt(percent) >= 25
//                             ? "HIGH (~" + percent + ")"
//                             : parseInt(percent) >= 10 && parseInt(percent) <= 20
//                             ? "MEDIUM (~" + percent + ")"
//                             : "LOW (~" + percent + ")"}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Market by Application */}
//             <div style={{ marginBottom: "25px" }}>
//               <h5 className="market_head_custom">Market by Application</h5>
//               <div>
//                 <table
//                   className="custom-resizable-table mb-0"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       className="custom-resizable-table-header"
//                       style={{ background: "#f1f5f9" }}
//                     >
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Application Segment
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {[
//                       [
//                         "Western Blot (Immunoblot) — RUO antibodies and reagents",
//                       ],
//                       [
//                         "Immunohistochemistry (IHC) and Spatial Biology — single-/multiplex tissue assays",
//                       ],
//                       [
//                         "Flow Cytometry — conjugated antibodies for cell phenotyping/signaling",
//                       ],
//                       [
//                         "ELISA/Immunoassays — PathScan kits and matched antibody pairs",
//                       ],
//                       [
//                         "Chromatin Immunoprecipitation (ChIP/CUT&RUN/CUT&Tag) — SimpleChIP kits & reagents",
//                       ],
//                       [
//                         "LC/MS Proteomics — PTMScan and TMT-based analytical services",
//                       ],
//                       [
//                         "Single-Cell Multimodal Analysis — InTraSeq protein+RNA on 10x Genomics workflows",
//                       ],
//                     ].map(([segment, percent], i) => (
//                       <tr
//                         className="gtr-row"
//                         key={i}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                       >
//                         <td className="gtr-cell">{segment}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Market by Geography */}
//             <div>
//               <h5 className="market_head_custom">Market by Geography</h5>
//               <div>
//                 <table
//                   className="custom-resizable-table mb-0"
//                   style={{ width: "100%", borderCollapse: "collapse" }}
//                 >
//                   <thead>
//                     <tr
//                       className="custom-resizable-table-header"
//                       style={{ background: "#f1f5f9" }}
//                     >
//                       <th>
//                         <div className="custom-resizable-table-th-content">
//                           Geography Segment
//                         </div>
//                       </th>
//                       <th style={{ textAlign: "center" }}>
//                         <div className="custom-resizable-table-th-content">
//                           Company Revenue %
//                         </div>
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {[
//                       [
//                         "North America (Direct presence; Mixed GTM) — primary operating geography",
//                         "44%",
//                       ],
//                       [
//                         "Europe (Direct presence; Mixed GTM) — secondary market focus",
//                         "28%",
//                       ],
//                       [
//                         "APAC (Direct presence in CN/JP; Mixed GTM) — growth market",
//                         "25%",
//                       ],
//                       [
//                         "LATAM (Distributor GTM) — emerging market opportunity",
//                         "1.5%",
//                       ],
//                       [
//                         "Middle East (Distributor GTM) — niche market presence",
//                         "1.2%",
//                       ],
//                       [
//                         "Africa (Distributor GTM) — minimal market presence",
//                         "0.3%",
//                       ],
//                     ].map(([geo, percent], i) => (
//                       <tr
//                         className="gtr-row"
//                         key={i}
//                         style={{ borderBottom: "1px solid #f1f5f9" }}
//                       >
//                         <td className="gtr-cell">{geo}</td>
//                         <td
//                           className="gtr-cell"
//                           style={{
//                             textAlign: "left",
//                             fontWeight: 600,
//                           }}
//                         >
//                           {parseInt(percent) >= 25
//                             ? "HIGH (~" + percent + ")"
//                             : parseInt(percent) >= 10 && parseInt(percent) <= 20
//                             ? "MEDIUM (~" + percent + ")"
//                             : "LOW (~" + percent + ")"}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Other Tabs Placeholders */}
//         {/* ---------------- Operations Tab ---------------- */}
//         {activeTab === "operations" && (
//           <div>
//             <h5 className="market_head_custom">Manufacturing Footprint</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Facility
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Location
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Function
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         {" "}
//                         Risk Level
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🏢 Danvers HQ</td>
//                     <td className="gtr-cell">Danvers, MA</td>
//                     <td className="gtr-cell">
//                       LEED-certified, Main Operations & R&D
//                     </td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#f59e0b",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         MEDIUM
//                       </span>
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🧪 Beverly Manufacturing</td>
//                     <td className="gtr-cell">Beverly, MA</td>
//                     <td className="gtr-cell">Antibody Production & QC</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#f59e0b",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         MEDIUM
//                       </span>
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🌍 Shanghai Office</td>
//                     <td className="gtr-cell">Shanghai, China</td>
//                     <td className="gtr-cell">APAC Distribution & Support</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#10b981",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         LOW
//                       </span>
//                     </td>
//                   </tr>
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">🌍 Netherlands Office</td>
//                     <td className="gtr-cell">Leiden, Netherlands</td>
//                     <td className="gtr-cell">
//                       European Distribution & Support
//                     </td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#10b981",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         LOW
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             <div
//               style={{
//                 background: "#fef3c7",
//                 border: "1px solid #f59e0b",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>⚠️</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#92400e",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Regional Manufacturing Concentration Risk
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Northeast US Operations:</strong> Primary manufacturing
//                 concentrated in Massachusetts creates moderate supply chain
//                 vulnerability, but global office network provides distribution
//                 resilience...
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ---------------- Distribution Tab ---------------- */}
//         {activeTab === "distribution" && (
//           <div>
//             <h5 className="market_head_custom">Go-to-Market Channels</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Channel Type
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Sales %
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Description
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         {" "}
//                         Strategic Impact
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🌐 Direct Sales</td>
//                     <td className="gtr-cell">65%</td>
//                     <td className="gtr-cell">
//                       Online platform and direct field sales
//                     </td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#10b981",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         OPTIMAL
//                       </span>
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🏪 Distributor Network</td>
//                     <td className="gtr-cell">25%</td>
//                     <td className="gtr-cell">
//                       Regional distributors and resellers
//                     </td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#f59e0b",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         MODERATE
//                       </span>
//                     </td>
//                   </tr>
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">🤝 Strategic Partnerships</td>
//                     <td className="gtr-cell">10%</td>
//                     <td className="gtr-cell">OEM and platform partnerships</td>
//                     <td className="gtr-cell">
//                       <span
//                         style={{
//                           background: "#10b981",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                         }}
//                       >
//                         STRATEGIC
//                       </span>
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//             <div
//               style={{
//                 background: "#f0f9ff",
//                 border: "1px solid #3b82f6",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>📊</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#1e40af",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Distribution Strategy Analysis
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Direct Sales Advantage:</strong> 65% direct channel
//                 maintains high margins and customer relationships, supported by
//                 strong digital presence and customer loyalty...
//               </div>
//             </div>
//           </div>
//         )}

//         {/* ---------------- Customers Tab ---------------- */}
//         {activeTab === "customers" && (
//           <div>
//             <h5 className="market_head_custom">Customer Segment Analysis</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Customer Segment
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Market Position
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Top Use Cases
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {/* Row 1 */}
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">
//                       Academic and Government Research Laboratories
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(4)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#10b981",
//                             }}
//                           ></div>
//                         ))}
//                         <div
//                           style={{
//                             width: "8px",
//                             height: "8px",
//                             borderRadius: "50%",
//                             background: "#e5e7eb",
//                           }}
//                         ></div>
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Strong Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Western blotting for signaling proteins;
//                       immunohistochemistry/immunofluorescence for biomarker
//                       studies; chromatin profiling for epigenetic research
//                     </td>
//                   </tr>
//                   {/* Row 2 */}
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">
//                       Biopharma Discovery & Translational Research
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(4)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#10b981",
//                             }}
//                           ></div>
//                         ))}
//                         <div
//                           style={{
//                             width: "8px",
//                             height: "8px",
//                             borderRadius: "50%",
//                             background: "#e5e7eb",
//                           }}
//                         ></div>
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Strong Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Target engagement and pathway quantitation (ELISA/WB);
//                       biomarker discovery; LC-MS proteomics (PTMScan/TMT)
//                     </td>
//                   </tr>
//                   {/* Row 3 */}
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">Core Facilities and CROs</td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(4)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#10b981",
//                             }}
//                           ></div>
//                         ))}
//                         <div
//                           style={{
//                             width: "8px",
//                             height: "8px",
//                             borderRadius: "50%",
//                             background: "#e5e7eb",
//                           }}
//                         ></div>
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Strong Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       High-throughput ELISA screening; high-content imaging with
//                       conjugated antibodies; flow cytometry panels; outsourced
//                       PTMScan Direct kinase panels for CRO pathway mapping
//                     </td>
//                   </tr>
//                   {/* Row 4 */}
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">
//                       Hospital/Pathology and Translational IHC Labs
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <div
//                         style={{
//                           display: "flex",
//                           justifyContent: "center",
//                           gap: "2px",
//                           alignItems: "center",
//                         }}
//                       >
//                         {[...Array(2)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#f59e0b",
//                             }}
//                           ></div>
//                         ))}
//                         {[...Array(3)].map((_, i) => (
//                           <div
//                             key={i}
//                             style={{
//                               width: "8px",
//                               height: "8px",
//                               borderRadius: "50%",
//                               background: "#e5e7eb",
//                             }}
//                           ></div>
//                         ))}
//                       </div>
//                       <div
//                         style={{
//                           fontSize: "10px",
//                           color: "#6b7280",
//                           marginTop: "4px",
//                         }}
//                       >
//                         Moderate Position
//                       </div>
//                     </td>
//                     <td className="gtr-cell">
//                       Single-plex IHC with IHC-validated antibodies; multiplex
//                       IHC (3-6-plex) spatial profiling for tumor
//                       microenvironment phenotyping; RUO antibodies for
//                       translational studies
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         )}

//         {/* ---------------- Competition Tab ---------------- */}
//         {activeTab === "competition" && (
//           <div>
//             <h5 className="market_head_custom">Competitive Landscape</h5>
//             <div>
//               <table
//                 className="custom-resizable-table mb-0"
//                 style={{ width: "100%", borderCollapse: "collapse" }}
//               >
//                 <thead>
//                   <tr
//                     className="custom-resizable-table-header"
//                     style={{ background: "#f1f5f9" }}
//                   >
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Competitor Category
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Key Players
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Threat Level
//                       </div>
//                     </th>
//                     <th>
//                       <div className="custom-resizable-table-th-content">
//                         Competitive Advantage
//                       </div>
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🌐 Global Giants</td>
//                     <td className="gtr-cell">
//                       Abcam, Thermo Fisher Scientific, Bio-Rad, Merck KGaA
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <span
//                         style={{
//                           background: "#ef4444",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         HIGH
//                       </span>
//                     </td>
//                     <td className="gtr-cell">
//                       Scale, portfolio breadth, global distribution, acquisition
//                       power
//                     </td>
//                   </tr>
//                   <tr
//                     className="gtr-row"
//                     style={{ borderBottom: "1px solid #f1f5f9" }}
//                   >
//                     <td className="gtr-cell">🎯 Specialized Players</td>
//                     <td className="gtr-cell">
//                       BioLegend, Santa Cruz Biotechnology, Proteintech,
//                       Bio-Techne
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <span
//                         style={{
//                           background: "#f59e0b",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         MEDIUM
//                       </span>
//                     </td>
//                     <td className="gtr-cell">
//                       Niche expertise, specialized technologies, focused
//                       customer segments
//                     </td>
//                   </tr>
//                   <tr className="gtr-row">
//                     <td className="gtr-cell">🚀 Emerging Competitors</td>
//                     <td className="gtr-cell">
//                       Sino Biological, Rockland Immunochemicals, GenScript
//                     </td>
//                     <td className="gtr-cell text-center">
//                       <span
//                         style={{
//                           background: "#10b981",
//                           color: "#fff",
//                           padding: "3px 8px",
//                           borderRadius: "4px",
//                           fontSize: "10px",
//                           fontWeight: 600,
//                         }}
//                       >
//                         LOW
//                       </span>
//                     </td>
//                     <td className="gtr-cell">
//                       Cost advantage, regional presence, custom services
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>

//             {/* Competitive Analysis */}
//             <div
//               style={{
//                 background: "#f0f9ff",
//                 border: "1px solid #3b82f6",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>🎯</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#1e40af",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Competitive Positioning Analysis
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Market Leadership:</strong> CST maintains co-leadership
//                 with Abcam in antibody citation share (~20%+ each). Key
//                 differentiators: validation rigor, signaling pathway expertise,
//                 and premium positioning vs broad portfolio competitors.
//               </div>
//             </div>

//             {/* Market Dynamics */}
//             <div
//               style={{
//                 background: "#fef2f2",
//                 border: "1px solid #ef4444",
//                 borderRadius: "8px",
//                 padding: "15px",
//                 marginTop: "15px",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: "10px",
//                   marginBottom: "12px",
//                 }}
//               >
//                 <div style={{ fontSize: "20px" }}>⚠️</div>
//                 <div
//                   style={{
//                     fontWeight: 700,
//                     color: "#dc2626",
//                     fontSize: "14px",
//                   }}
//                 >
//                   Competitive Threats
//                 </div>
//               </div>
//               <div
//                 style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
//               >
//                 <strong>Scale & Acquisition Risk:</strong> Thermo Fisher ($40B+)
//                 and other giants can acquire specialized players and commoditize
//                 premium segments. Rising competition from Asian suppliers with
//                 cost advantages challenges traditional pricing models.
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default CompanyBaselineProfile;

import React, { useEffect, useState } from "react";
import * as FeatherIcon from "react-feather";
import { useParams } from "react-router-dom";
import "./CompanyBaselineProfile.css";
import { useDispatch, useSelector } from "react-redux";
import { submitBaselineMarketDetailsRequest } from "../../../../../store/features/actions/baselineMarketDetailsActions";
import { transformBaselineData } from "../../../../../services/commonService";

const CompanyBaselineProfile = ({ baselineData }) => {
  const [activeTab, setActiveTab] = useState("products");
  const { clientName, competitorName } = useParams();
  const [companyData, setCompanyData] = useState(null);
  const [marketByTechnology, setMarketByTechnology] = useState([]);
  const [marketByApplication, setMarketByApplication] = useState([]);
  const [marketByGeography, setMarketByGeography] = useState([]);
  const dispatch = useDispatch();

  // const { loading, successMessage, errorMessage } = useSelector(
  //   (state) => state.baselineMarketDetailsReducer
  // );

  const formData = {
    client: clientName ?? "HB Fuller",
    company: competitorName ?? "Tailored Chemical Products",
  };
  // useEffect(() => {
  //   dispatch(submitBaselineMarketDetailsRequest(formData));
  // }, []);

  // useEffect(() => {
  //   if (successMessage) {
  //     let tempMarketByTechnology = successMessage.filter(
  //       (marketDetail) => marketDetail?.subdimension === "market by technology"
  //     );
  //     let tempMarketByApplication = successMessage.filter(
  //       (marketDetail) => marketDetail?.subdimension === "market by application"
  //     );
  //     let tempMarketByGeography = successMessage.filter(
  //       (marketDetail) => marketDetail?.subdimension === "market by geography"
  //     );
  //     setMarketByTechnology(tempMarketByTechnology);
  //     setMarketByApplication(tempMarketByApplication);
  //     setMarketByGeography(tempMarketByGeography);
  //   }
  // }, [successMessage]);

  useEffect(() => {
    const transformedData = transformBaselineData(baselineData);
    setCompanyData(transformedData);
  }, [baselineData]);

  // const companyData = {
  //   companyInfo: {
  //     name: "📋 Company Baseline Profile",
  //     overallConfidence: "85%",
  //   },
  //   tabs: [
  //     { key: "products", label: "Products" },
  //     { key: "markets", label: "Markets" },
  //     { key: "operations", label: "Operations" },
  //     { key: "distribution", label: "Distribution" },
  //     { key: "customers", label: "Customers" },
  //     { key: "competition", label: "Competition" },
  //   ],
  //   products: [
  //     {
  //       line: "Chromatin Profiling (SimpleChIP, CUT&RUN, CUT&Tag)",
  //       category: "CASH COW (SimpleChIP) + GROWTH ENGINE (CUT&RUN/Tag)",
  //       bgColor: "#dc2626",
  //     },
  //     {
  //       line: "Primary Antibodies & Conjugates (Rabbit mAb, SignalFlex)",
  //       category: "CASH COW",
  //       bgColor: "#dc2626",
  //     },
  //     {
  //       line: "Proteomics Analytical Services (PTMScan & Targeted/Discovery)",
  //       category: "DIVERSIFICATION + STRATEGIC DEFENSE",
  //       bgColor: "#dc2626",
  //     },
  //     {
  //       line: "Cytokines & Growth Factors (Recombinant Proteins)",
  //       category: "DIVERSIFICATION",
  //       bgColor: "#059669",
  //     },
  //     {
  //       line: "SignalStar Multiplex IHC Kits & Reagents",
  //       category: "GROWTH ENGINE",
  //       bgColor: "#059669",
  //     },
  //     {
  //       line: "InTraSeq Single‑Cell Protein+RNA (3′ workflow)",
  //       category: "INNOVATION SHOWCASE → GROWTH ENGINE",
  //       bgColor: "#059669",
  //     },
  //     {
  //       line: "WB/IP Detection, Secondary Antibodies, and Buffers",
  //       category: "PORTFOLIO FILL + STRATEGIC DEFENSE",
  //       bgColor: "#059669",
  //     },
  //     {
  //       line: "PathScan ELISA Kits & Antibody Pairs",
  //       category: "PORTFOLIO FILL → CASH COW",
  //       bgColor: "#6366f1",
  //     },
  //     {
  //       line: "Custom & Bulk Services (Formulations, Conjugation, Peptides)",
  //       category: "STRATEGIC DEFENSE",
  //       bgColor: "#6366f1",
  //     },
  //   ],
  //   markets: {
  //     technology: [
  //       {
  //         segment:
  //           "Recombinant Rabbit Monoclonal Antibodies (RUO primary antibodies)",
  //         percent: "58%",
  //       },
  //       {
  //         segment:
  //           "Conjugated/Carrier-free Antibodies and Custom Labeling (Reagent kits and services)",
  //         percent: "12%",
  //       },
  //       {
  //         segment:
  //           "Multiplex Immunohistochemistry (SignalStar mIHC; Platform/Reagents)",
  //         percent: "6%",
  //       },
  //       {
  //         segment: "PathScan ELISA Kits (RUO immunoassays)",
  //         percent: "8%",
  //       },
  //       {
  //         segment:
  //           "Proteomics Analytical Services (PTMScan Discovery/Direct, TMT Total Proteome)",
  //         percent: "7%",
  //       },
  //       {
  //         segment: "Chromatin Profiling (SimpleChIP Kits & Reagents)",
  //         percent: "6%",
  //       },
  //       {
  //         segment:
  //           "Single-Cell Multimodal Protein+RNA (InTraSeq; Platform/Reagents)",
  //         percent: "3%",
  //       },
  //     ],
  //     application: [
  //       {
  //         segment: "Western Blot (Immunoblot) — RUO antibodies and reagents",
  //       },
  //       {
  //         segment:
  //           "Immunohistochemistry (IHC) and Spatial Biology — single-/multiplex tissue assays",
  //       },
  //       {
  //         segment:
  //           "Flow Cytometry — conjugated antibodies for cell phenotyping/signaling",
  //       },
  //       {
  //         segment:
  //           "ELISA/Immunoassays — PathScan kits and matched antibody pairs",
  //       },
  //       {
  //         segment:
  //           "Chromatin Immunoprecipitation (ChIP/CUT&RUN/CUT&Tag) — SimpleChIP kits & reagents",
  //       },
  //       {
  //         segment:
  //           "LC/MS Proteomics — PTMScan and TMT-based analytical services",
  //       },
  //       {
  //         segment:
  //           "Single-Cell Multimodal Analysis — InTraSeq protein+RNA on 10x Genomics workflows",
  //       },
  //     ],
  //     geography: [
  //       {
  //         segment:
  //           "North America (Direct presence; Mixed GTM) — primary operating geography",
  //         percent: "44%",
  //       },
  //       {
  //         segment:
  //           "Europe (Direct presence; Mixed GTM) — secondary market focus",
  //         percent: "28%",
  //       },
  //       {
  //         segment: "APAC (Direct presence in CN/JP; Mixed GTM) — growth market",
  //         percent: "25%",
  //       },
  //       {
  //         segment: "LATAM (Distributor GTM) — emerging market opportunity",
  //         percent: "1.5%",
  //       },
  //       {
  //         segment: "Middle East (Distributor GTM) — niche market presence",
  //         percent: "1.2%",
  //       },
  //       {
  //         segment: "Africa (Distributor GTM) — minimal market presence",
  //         percent: "0.3%",
  //       },
  //     ],
  //   },
  //   operations: {
  //     facilities: [
  //       {
  //         name: "🏢 Danvers HQ",
  //         location: "Danvers, MA",
  //         function: "LEED-certified, Main Operations & R&D",
  //         riskLevel: "MEDIUM",
  //         riskColor: "#f59e0b",
  //       },
  //       {
  //         name: "🧪 Beverly Manufacturing",
  //         location: "Beverly, MA",
  //         function: "Antibody Production & QC",
  //         riskLevel: "MEDIUM",
  //         riskColor: "#f59e0b",
  //       },
  //       {
  //         name: "🌍 Shanghai Office",
  //         location: "Shanghai, China",
  //         function: "APAC Distribution & Support",
  //         riskLevel: "LOW",
  //         riskColor: "#10b981",
  //       },
  //       {
  //         name: "🌍 Netherlands Office",
  //         location: "Leiden, Netherlands",
  //         function: "European Distribution & Support",
  //         riskLevel: "LOW",
  //         riskColor: "#10b981",
  //       },
  //     ],
  //     riskNote: {
  //       title: "Regional Manufacturing Concentration Risk",
  //       icon: "⚠️",
  //       content:
  //         "<strong>Northeast US Operations:</strong> Primary manufacturing concentrated in Massachusetts creates moderate supply chain vulnerability, but global office network provides distribution resilience...",
  //       bgColor: "#fef3c7",
  //       borderColor: "#f59e0b",
  //       titleColor: "#92400e",
  //     },
  //   },
  //   distribution: {
  //     channels: [
  //       {
  //         type: "🌐 Direct Sales",
  //         percent: "65%",
  //         description: "Online platform and direct field sales",
  //         impact: "OPTIMAL",
  //         impactColor: "#10b981",
  //       },
  //       {
  //         type: "🏪 Distributor Network",
  //         percent: "25%",
  //         description: "Regional distributors and resellers",
  //         impact: "MODERATE",
  //         impactColor: "#f59e0b",
  //       },
  //       {
  //         type: "🤝 Strategic Partnerships",
  //         percent: "10%",
  //         description: "OEM and platform partnerships",
  //         impact: "STRATEGIC",
  //         impactColor: "#10b981",
  //       },
  //     ],
  //     analysis: {
  //       title: "Distribution Strategy Analysis",
  //       icon: "📊",
  //       content:
  //         "<strong>Direct Sales Advantage:</strong> 65% direct channel maintains high margins and customer relationships, supported by strong digital presence and customer loyalty...",
  //       bgColor: "#f0f9ff",
  //       borderColor: "#3b82f6",
  //       titleColor: "#1e40af",
  //     },
  //   },
  //   customers: [
  //     {
  //       segment: "Academic and Government Research Laboratories",
  //       position: {
  //         filledDots: 4,
  //         totalDots: 5,
  //         label: "Strong Position",
  //         dotColor: "#10b981",
  //       },
  //       useCases:
  //         "Western blotting for signaling proteins; immunohistochemistry/immunofluorescence for biomarker studies; chromatin profiling for epigenetic research",
  //     },
  //     {
  //       segment: "Biopharma Discovery & Translational Research",
  //       position: {
  //         filledDots: 4,
  //         totalDots: 5,
  //         label: "Strong Position",
  //         dotColor: "#10b981",
  //       },
  //       useCases:
  //         "Target engagement and pathway quantitation (ELISA/WB); biomarker discovery; LC-MS proteomics (PTMScan/TMT)",
  //     },
  //     {
  //       segment: "Core Facilities and CROs",
  //       position: {
  //         filledDots: 4,
  //         totalDots: 5,
  //         label: "Strong Position",
  //         dotColor: "#10b981",
  //       },
  //       useCases:
  //         "High-throughput ELISA screening; high-content imaging with conjugated antibodies; flow cytometry panels; outsourced PTMScan Direct kinase panels for CRO pathway mapping",
  //     },
  //     {
  //       segment: "Hospital/Pathology and Translational IHC Labs",
  //       position: {
  //         filledDots: 2,
  //         totalDots: 5,
  //         label: "Moderate Position",
  //         dotColor: "#f59e0b",
  //       },
  //       useCases:
  //         "Single-plex IHC with IHC-validated antibodies; multiplex IHC (3-6-plex) spatial profiling for tumor microenvironment phenotyping; RUO antibodies for translational studies",
  //     },
  //   ],
  //   competition: {
  //     competitors: [
  //       {
  //         category: "🌐 Global Giants",
  //         players: "Abcam, Thermo Fisher Scientific, Bio-Rad, Merck KGaA",
  //         threatLevel: "HIGH",
  //         threatColor: "#ef4444",
  //         advantage:
  //           "Scale, portfolio breadth, global distribution, acquisition power",
  //       },
  //       {
  //         category: "🎯 Specialized Players",
  //         players:
  //           "BioLegend, Santa Cruz Biotechnology, Proteintech, Bio-Techne",
  //         threatLevel: "MEDIUM",
  //         threatColor: "#f59e0b",
  //         advantage:
  //           "Niche expertise, specialized technologies, focused customer segments",
  //       },
  //       {
  //         category: "🚀 Emerging Competitors",
  //         players: "Sino Biological, Rockland Immunochemicals, GenScript",
  //         threatLevel: "LOW",
  //         threatColor: "#10b981",
  //         advantage: "Cost advantage, regional presence, custom services",
  //       },
  //     ],
  //     analysis: [
  //       {
  //         title: "Competitive Positioning Analysis",
  //         icon: "🎯",
  //         content:
  //           "<strong>Market Leadership:</strong> CST maintains co-leadership with Abcam in antibody citation share (~20%+ each). Key differentiators: validation rigor, signaling pathway expertise, and premium positioning vs broad portfolio competitors.",
  //         bgColor: "#f0f9ff",
  //         borderColor: "#3b82f6",
  //         titleColor: "#1e40af",
  //       },
  //       {
  //         title: "Competitive Threats",
  //         icon: "⚠️",
  //         content:
  //           "<strong>Scale & Acquisition Risk:</strong> Thermo Fisher ($40B+) and other giants can acquire specialized players and commoditize premium segments. Rising competition from Asian suppliers with cost advantages challenges traditional pricing models.",
  //         bgColor: "#fef2f2",
  //         borderColor: "#ef4444",
  //         titleColor: "#dc2626",
  //       },
  //     ],
  //   },
  // };

  // Helper function to get percentage level
  const getPercentageLevel = (percent) => {
    const num = parseInt(percent);
    if (num >= 25) return "HIGH (~" + percent + "%)";
    if (num >= 10 && num < 25) return "MEDIUM (~" + percent + "%)";
    if (num >= 0 && num < 10) return "LOW (~" + percent + "%)";
    return "NA";
  };

  // Helper component for dot rating
  const DotRating = ({ filledDots, totalDots, dotColor }) => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "2px",
        alignItems: "center",
      }}
    >
      {[...Array(filledDots)].map((_, i) => (
        <div
          key={i}
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: dotColor,
          }}
        ></div>
      ))}
      {[...Array(totalDots - filledDots)].map((_, i) => (
        <div
          key={i}
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: "#e5e7eb",
          }}
        ></div>
      ))}
    </div>
  );

  // Helper component for info boxes
  const InfoBox = ({ data }) => (
    <div
      style={{
        background: data.bgColor,
        border: `1px solid ${data.borderColor}`,
        borderRadius: "8px",
        padding: "15px",
        marginTop: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "12px",
        }}
      >
        <div style={{ fontSize: "20px" }}>{data.icon}</div>
        <div
          style={{
            fontWeight: 700,
            color: data.titleColor,
            fontSize: "14px",
          }}
        >
          {data.title}
        </div>
      </div>
      <div
        style={{ fontSize: "12px", color: "#374151", lineHeight: 1.4 }}
        dangerouslySetInnerHTML={{ __html: data.content }}
      />
    </div>
  );

  return (
    <div className="company_baseline_wrapper">
      {/* Header */}
      <div className="company_head_block">
        <h3 className="company_name">{companyData?.companyInfo?.name}</h3>
        {/* <div className="overall_confidance">
          Overall Confidence: {companyData?.companyInfo?.overallConfidence}
        </div> */}
      </div>

      {/* Tabs */}
      <div className="company_tab_wrapper">
        <div className="company_tab_row">
          {/* {companyData?.tabs?.length > 0 &&
            companyData.tabs.map((tab) => ( */}
          {companyData?.tabs?.length > 0 &&
            companyData.tabs
              .filter((tab) => {
                if (tab.key === "products")
                  return companyData?.products?.length > 0;
                if (tab.key === "markets")
                  return (
                    companyData?.markets?.technology?.length > 0 ||
                    companyData?.markets?.application?.length > 0 ||
                    companyData?.markets?.geography?.length > 0
                  );
                if (tab.key === "operations")
                  return companyData?.operations?.facilities?.length > 0;
                if (tab.key === "distribution")
                  return companyData?.distribution?.channels?.length > 0;
                if (tab.key === "customers")
                  return companyData?.customers?.length > 0;
                if (tab.key === "competition")
                  return companyData?.competition?.competitors?.length > 0;
                return true;
              })
              .map((tab) => (
                <button
                  className={`copmany_tab_btn ${
                    activeTab === tab.key ? "company_tab_btn_active" : ""
                  }`}
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="company_tab_content_wrapper">
        {/* Products Tab */}
        {/* {activeTab === "products" && ( */}
        {activeTab === "products" && companyData?.products?.length > 0 && (
          <div className="company_content_block">
            <table
              className="custom-resizable-table mb-0"
              style={{ width: "100%", borderCollapse: "collapse" }}
            >
              <thead className="">
                <tr
                  className="custom-resizable-table-header"
                  style={{ background: "#f1f5f9" }}
                >
                  <th className="" style={{ fontSize: "12px" }}>
                    <div className="custom-resizable-table-th-content">
                      Product Line
                    </div>
                  </th>
                  <th className="" style={{ fontSize: "12px" }}>
                    <div className="custom-resizable-table-th-content">
                      Strategic Category
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="">
                {companyData?.products.map((product, i) => (
                  <tr
                    className="gtr-row"
                    key={i}
                    style={{ borderBottom: "1px solid #f1f5f9" }}
                  >
                    <td className="gtr-cell">{product.line}</td>
                    <td className="gtr-cell" style={{ fontSize: "11px" }}>
                      <span
                        className="company_content_td_span"
                        style={{
                          background: product.bgColor,
                          color: "#fff",
                          padding: "3px 8px",
                          borderRadius: "4px",
                          fontWeight: 600,
                        }}
                      >
                        {product.category}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* Markets Tab */}
        {activeTab === "markets" && (
          <div className="company_content_block">
            {/* Market by Technology */}
            {/* <div style={{ marginBottom: "25px" }}> */}
            {companyData?.markets?.technology?.length > 0 && (
              <div style={{ marginBottom: "25px" }}>
                <h5 className="market_head_custom">Market by Technology</h5>
                <div>
                  <table
                    className="custom-resizable-table mb-0"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        className="custom-resizable-table-header"
                        style={{ background: "#f1f5f9" }}
                      >
                        <th>
                          <div className="custom-resizable-table-th-content">
                            Technology Segment
                          </div>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <div className="custom-resizable-table-th-content">
                            Revenue Contribution (%)
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {companyData.markets.technology.map((market, i) => (
                        <tr
                          className="gtr-row"
                          key={i}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                        >
                          <td className="gtr-cell">{market.segment}</td>
                          <td
                            className="gtr-cell"
                            style={{
                              textAlign: "left",
                              fontWeight: 600,
                            }}
                          >
                            {getPercentageLevel(market.percent)}
                          </td>
                        </tr>
                      ))}
                      {/* {marketByTechnology.map((market, i) => (
                      <tr
                        className="gtr-row"
                        key={i}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td className="gtr-cell">{market.segment}</td>
                        <td
                          className="gtr-cell"
                          style={{
                            textAlign: "left",
                            fontWeight: 600,
                          }}
                        >
                          {getPercentageLevel(market.company_market_share)}
                        </td>
                      </tr>
                    ))} */}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Market by Application */}
            {companyData?.markets?.application?.length > 0 && (
              <div style={{ marginBottom: "25px" }}>
                <h5 className="market_head_custom">Market by Application</h5>
                <div>
                  <table
                    className="custom-resizable-table mb-0"
                    style={{ width: "100%", borderCollapse: "collapse" }}
                  >
                    <thead>
                      <tr
                        className="custom-resizable-table-header"
                        style={{ background: "#f1f5f9" }}
                      >
                        <th>
                          <div className="custom-resizable-table-th-content">
                            Application Segment
                          </div>
                        </th>
                        <th style={{ textAlign: "center" }}>
                          <div className="custom-resizable-table-th-content">
                            Revenue Contribution (%)
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {companyData.markets.application.map((app, i) => (
                        <tr
                          className="gtr-row"
                          key={i}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                        >
                          <td className="gtr-cell">{app.segment}</td>
                          <td
                            className="gtr-cell"
                            style={{
                              textAlign: "left",
                              fontWeight: 600,
                            }}
                          >
                            {getPercentageLevel(app.percent)}
                          </td>
                        </tr>
                      ))}
                      {/* {marketByApplication.map((market, i) => (
                      <tr
                        className="gtr-row"
                        key={i}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td className="gtr-cell">{market.segment}</td>
                        <td
                          className="gtr-cell"
                          style={{
                            textAlign: "left",
                            fontWeight: 600,
                          }}
                        >
                          {getPercentageLevel(market.company_market_share)}
                        </td>
                      </tr>
                    ))} */}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            {/* Market by Geography */}
            <div>
              <h5 className="market_head_custom">Market by Geography</h5>
              <div>
                <table
                  className="custom-resizable-table mb-0"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr
                      className="custom-resizable-table-header"
                      style={{ background: "#f1f5f9" }}
                    >
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Geography Segment
                        </div>
                      </th>
                      <th style={{ textAlign: "center" }}>
                        <div className="custom-resizable-table-th-content">
                          Revenue Contribution (%)
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {companyData.markets.geography.map((geo, i) => (
                      <tr
                        className="gtr-row"
                        key={i}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td className="gtr-cell">{geo.segment}</td>
                        <td
                          className="gtr-cell"
                          style={{
                            textAlign: "left",
                            fontWeight: 600,
                          }}
                        >
                          {getPercentageLevel(geo.percent)}
                        </td>
                      </tr>
                    ))}
                    {/* {marketByGeography.map((market, i) => (
                      <tr
                        className="gtr-row"
                        key={i}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td className="gtr-cell">{market.segment}</td>
                        <td
                          className="gtr-cell"
                          style={{
                            textAlign: "left",
                            fontWeight: 600,
                          }}
                        >
                          {getPercentageLevel(market.company_market_share)}
                        </td>
                      </tr>
                    ))} */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {/* Operations Tab */}
        {/* {activeTab === "operations" && ( */}
        {activeTab === "operations" &&
          companyData?.operations?.facilities?.length > 0 && (
            <div>
              <h5 className="market_head_custom">Manufacturing Footprint</h5>
              <div>
                <table
                  className="custom-resizable-table mb-0"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr
                      className="custom-resizable-table-header"
                      style={{ background: "#f1f5f9" }}
                    >
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Facility
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Location
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Function
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Risk Level
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {companyData.operations.facilities.map((facility, i) => (
                      <tr
                        className="gtr-row"
                        key={i}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td className="gtr-cell">{facility.name}</td>
                        <td className="gtr-cell">{facility.location}</td>
                        <td className="gtr-cell">{facility.function}</td>
                        <td className="gtr-cell">
                          <span
                            style={{
                              background: facility.riskColor,
                              color: "#fff",
                              padding: "3px 8px",
                              borderRadius: "4px",
                              fontSize: "10px",
                            }}
                          >
                            {facility.riskLevel}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* <InfoBox data={companyData.operations.riskNote} /> */}
            </div>
          )}

        {/* Distribution Tab */}
        {/* {activeTab === "distribution" && ( */}
        {activeTab === "distribution" &&
          companyData?.distribution?.channels?.length > 0 && (
            <div>
              <h5 className="market_head_custom">Go-to-Market Channels</h5>
              <div>
                <table
                  className="custom-resizable-table mb-0"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr
                      className="custom-resizable-table-header"
                      style={{ background: "#f1f5f9" }}
                    >
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Channel Type
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Sales %
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Description
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Strategic Impact
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {companyData.distribution.channels.map((channel, i) => (
                      <tr
                        className="gtr-row"
                        key={i}
                        style={{ borderBottom: "1px solid #f1f5f9" }}
                      >
                        <td className="gtr-cell">{channel.type}</td>
                        <td className="gtr-cell">{channel.percent}</td>
                        <td className="gtr-cell">{channel.description}</td>
                        <td className="gtr-cell">
                          <span
                            style={{
                              background: channel.impactColor,
                              color: "#fff",
                              padding: "3px 8px",
                              borderRadius: "4px",
                              fontSize: "10px",
                            }}
                          >
                            {channel.impact}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {/* <InfoBox data={companyData.distribution.analysis} /> */}
            </div>
          )}

        {/* Customers Tab */}
        {/* {activeTab === "customers" && ( */}
        {activeTab === "customers" && companyData?.customers?.length > 0 && (
          <div>
            <h5 className="market_head_custom">Customer Segment Analysis</h5>
            <div>
              <table
                className="custom-resizable-table mb-0"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr
                    className="custom-resizable-table-header"
                    style={{ background: "#f1f5f9" }}
                  >
                    <th>
                      <div className="custom-resizable-table-th-content">
                        Customer Segment
                      </div>
                    </th>
                    <th>
                      <div className="custom-resizable-table-th-content">
                        Market Position
                      </div>
                    </th>
                    <th>
                      <div className="custom-resizable-table-th-content">
                        Top Use Cases
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {companyData.customers.map((customer, i) => (
                    <tr
                      className="gtr-row"
                      key={i}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                    >
                      <td className="gtr-cell">{customer.segment}</td>
                      <td className="gtr-cell text-center">
                        <DotRating
                          filledDots={customer.position.filledDots}
                          totalDots={customer.position.totalDots}
                          dotColor={customer.position.dotColor}
                        />
                        <div
                          style={{
                            fontSize: "10px",
                            color: "#6b7280",
                            marginTop: "4px",
                          }}
                        >
                          {customer.position.label}
                        </div>
                      </td>
                      <td className="gtr-cell">{customer.useCases}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Competition Tab */}
        {/* {activeTab === "competition" && ( */}
        {activeTab === "competition" &&
          companyData?.competition?.competitors?.length > 0 && (
            <div>
              <h5 className="market_head_custom">Competitive Landscape</h5>
              <div>
                <table
                  className="custom-resizable-table mb-0"
                  style={{ width: "100%", borderCollapse: "collapse" }}
                >
                  <thead>
                    <tr
                      className="custom-resizable-table-header"
                      style={{ background: "#f1f5f9" }}
                    >
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Competitor Category
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Key Players
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Threat Level
                        </div>
                      </th>
                      <th>
                        <div className="custom-resizable-table-th-content">
                          Competitive Advantage
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {companyData.competition.competitors.map(
                      (competitor, i) => (
                        <tr
                          className="gtr-row"
                          key={i}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                        >
                          <td className="gtr-cell">{competitor.category}</td>
                          <td className="gtr-cell">{competitor.players}</td>
                          <td className="gtr-cell text-center">
                            <span
                              style={{
                                background: competitor.threatColor,
                                color: "#fff",
                                padding: "3px 8px",
                                borderRadius: "4px",
                                fontSize: "10px",
                                fontWeight: 600,
                              }}
                            >
                              {competitor.threatLevel}
                            </span>
                          </td>
                          <td className="gtr-cell">{competitor.advantage}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>

              {/* Competitive Analysis Boxes */}
              {/* {companyData.competition.analysis.map((analysis, i) => (
              <InfoBox key={i} data={analysis} />
            ))} */}
            </div>
          )}
      </div>
    </div>
  );
};

export default CompanyBaselineProfile;
